import Signal from "./signal";

/**
 * If you start many async procedures at nearly the same time they are not
 * guaranteed to complete in order. This class helps by dropping the effects of
 * async procedures that finish after a procedure started at a later time.
 */
export class OrderedEffects {
    serial: number = 0;

    onError = new Signal<[error: Error]>('onError', 'ordered-effects');

    async queue<T>(cause: () => Promise<T>, effect: (arg: T) => void) {
        const sequence = this.serial++;

        try {
            let result = await cause();

            if(this.serial > sequence+1) {
                // drop the change
            }
            else {
                effect(result);
            }
        } catch(error) {
            this.onError.trigger(error);
        }

    }
}
export default OrderedEffects;
